export default __webpack_public_path__ + "static/media/openseadragon-logo_n.3ef0f3f9.png";